import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6767c8c3")
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass({
    header:true,
  })
}
const _hoisted_2 = { class: "brand" }
const _hoisted_3 = { class: "centre" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_Account = _resolveComponent("Account")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "icon _img",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toBrowse && _ctx.toBrowse(...args)))
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.$route.name=='LandingPage')
        ? (_openBlock(), _createBlock(_component_IconButton, {
            key: 0,
            route: "/account/login",
            text: "Get started"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_Account, {
        player: _ctx.$store.state.Auth.user
      }, null, 8, ["player"])
    ])
  ]))
}